//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//Modelos
import QuestionarioQuestao, { TIPO_INTEIRO, TIPO_NUMERICO } from '../../models/QuestionarioQuestao';
import ErroQuestionarioQuestao from '../../models/ErroQuestionarioQuestao';
//Utils
import { validarInteiro, validarDecimal } from '../../utils/validacao';

/**
 * Componente para renderizar a opção de limite da questão
 */
class QuestaoLimite extends Component {
    constructor(props) {
        super(props);
        //Bindigs
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Trata as alterações no checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Não dispara a alteração se for somente leitura
        if (!this.props.readOnly) {
            //Copia o valor recebido
            const questao = QuestionarioQuestao.clone(this.props.questao);
            //Atualiza somente o valor do campo alterado
            questao.limitaValor = event.target.checked;
            //Atualiza o estado
            if (this.props.onChange)
                this.props.onChange(questao);
        }
    }

    /**
     * Trata as alterações no checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleChange(event) {
        //Não dispara a alteração se for somente leitura
        if (!this.props.readOnly) {
            const valor = event.target.value;
            if (this.validarValor(valor)) {
                //Copia o valor recebido
                const questao = QuestionarioQuestao.clone(this.props.questao);
                //Atualiza somente o valor do campo alterado
                questao[event.target.name] = valor;
                //Atualiza o estado
                if (this.props.onChange)
                    this.props.onChange(questao);    
            }
        }
    }
    
    /**
     * Valida o valor informado pelo usuário
     * @param {String} valor Valor informado pelo usuário
     * @returns {Boolean} Retorna a indicação se o valor é válido ou não
     */
    validarValor(valor) {
        //Caso seja uma questão do tipo inteiro
        if (this.props.questao.tipo === TIPO_INTEIRO)
            return validarInteiro(valor);
        //Caso seja uma questão do tipo numérico
        else if (this.props.questao.tipo === TIPO_NUMERICO)
            return validarDecimal(valor);
        else
            return false;
    }

    /**
     * Converte um número para uma string, trocando o ponto por vírgula
     * @param {Number} valor Valor a ser convertido
     * @returns {String} Valor convertido para string
     */
    converterParaString(valor) {
        if (valor === null)
            return '';
        else if (this.props.questao.tipo === TIPO_NUMERICO)
            return valor.toString().replace('.', ',');
        else
            return valor.toString();
    }

    render() {
        const { questao, erros } = this.props;

        return (
            <Fragment>
                <Grid item xs={12} sm={4} >
                    <FormControl fullWidth variant="standard" error={!!erros.limitaValor} >
                        <FormControlLabel
                            id="limitavalor-label"
                            control={
                                <Checkbox
                                    checked={questao.limitaValor}
                                    onChange={this.handleCheckboxChange}
                                    name="exibeGrafico"
                                    color="primary"
                                />
                            }
                            label="Intervalo de valor (min. e máx.)"
                        />
                        <FormHelperText id="limitavalor-helper">{erros.limitaValor}</FormHelperText>
                    </FormControl>
                </Grid>
                {
                    questao.limitaValor &&
                        <Fragment>
                            <Grid item xs={12} sm={4} >
                                <TextField
                                    name="valorMinimo"
                                    label="Valor mínimo"
                                    placeholder="Valor mínimo"
                                    variant="outlined" 
                                    size="small"
                                    fullWidth 
                                    onChange={this.handleChange}
                                    required={questao.limitaValor}
                                    value={this.converterParaString(questao.valorMinimo)} 
                                    error={!!erros.valorMinimo}
                                    helperText={erros.valorMinimo}
                                />  
                            </Grid>
                            <Grid item xs={12} sm={4} >
                                <TextField
                                    name="valorMaximo"
                                    label="Valor valorMáximo"
                                    placeholder="Valor máximo"
                                    variant="outlined" 
                                    size="small"
                                    fullWidth 
                                    onChange={this.handleChange}
                                    required={questao.limitaValor}
                                    value={this.converterParaString(questao.valorMaximo)} 
                                    error={!!erros.valorMaximo}
                                    helperText={erros.valorMaximo}
                                />  
                            </Grid>
                        </Fragment>
                }
            </Fragment>
        );
    }
}

QuestaoLimite.propTypes = {
    /** Dados da questão */
    questao: PropTypes.instanceOf(QuestionarioQuestao).isRequired,
    /** Mensagens de erro da questão, referente as opções de resposta */
    erros: PropTypes.instanceOf(ErroQuestionarioQuestao),
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Evento disparado quando há alteração nas opções da questão */
    onChange: PropTypes.func
};

QuestaoLimite.defaultProps = {
    erros: new ErroQuestionarioQuestao(),
    readOnly: false
};

export default QuestaoLimite;